import sectorsData from '../data/sectorsData';

// Index curated taxonomy landings, not arbitrary combinations of filters or
// user-entered search terms. Preserve pagination because each page differs.
export const searchSeo = (search) => {
  const incoming = new URLSearchParams(search);
  const params = new URLSearchParams();
  const sector = incoming.get('sectors') || incoming.get('sector');
  const category = incoming.get('categories') || incoming.get('category');
  const subcategory = incoming.get('subcategories') || incoming.get('subcategory');
  let noindex = false;
  let label = '';
  const taxonomy = sectorsData[sector];
  if (sector) {
    params.set('sector', sector);
    noindex = !taxonomy;
    label = sector;
  }
  if (category) {
    params.set('category', category);
    noindex ||= !taxonomy?.categories?.includes(category);
    label = category;
  }
  if (subcategory) {
    params.set('subcategory', subcategory);
    noindex ||= !taxonomy?.subcategories?.[category]?.includes(subcategory);
    label = subcategory;
  }
  for (const key of ['q', 'search', 'brands', 'price_min', 'price_max', 'countries',
    'states', 'cities', 'stock_min', 'condition']) {
    const value = incoming.get(key);
    if (value) { params.set(key, value); noindex = true; }
  }
  const page = Number(incoming.get('page') || 1);
  if (Number.isSafeInteger(page) && page > 1) params.set('page', String(page));
  else if (page !== 1) noindex = true;
  const query = params.toString();
  return { canonicalBase: `/search${query ? `?${query}` : ''}`, label, noindex, nofollow: false };
};
